module.exports = __webpack_public_path__ + "img/increase.be7004ef.svg";